import React from 'react';
import { HeaderLogo, LinkedIn } from '../../assets';
import '../AboutSection/AboutSection.css';
import { Divider } from 'antd';
import { Link } from 'react-router-dom';

const COMPANY_LINKS = [
  { label: 'About Us', link: '/about', internal: true },
  { label: 'Blog', link: 'https://blog.shipmnts.com/' },
  { label: 'Help', link: 'https://help.shipmnts.com' },
  { label: 'Refer a Friend', link: 'https://blog.shipmnts.com/shipmnts-referral-program' },
];

const LEGAL_LINKS = [
  { label: 'Privacy Policy', link: '/privacy-policy', internal: true },
  { label: 'Cookie Policy', link: '/cookie-policy', internal: true },
  { label: 'Terms of Services', link: '/terms-of-services', internal: true },
];

function FooterLink({ label, link, internal }) {
  if (internal) {
    return (
      <Link to={link} className="body-text-3">
        {label}
      </Link>
    );
  }
  return (
    <a href={link} target="_blank" rel="noreferrer" className="body-text-3">
      {label}
    </a>
  );
}

export default function AboutSection() {
  return (
    <div className="about-container">
      <div id="about" className="about-section">
        {/* Brand blurb */}
        <div className="about-content">
          <img src={HeaderLogo} alt="SHIPMNTS" className="footer-logo" />
          <div className="body-text-3">
            A tech platform for Freight Forwarders, CHAs, Transporters, 4PLs, Importers and
            Exporters: streamlining Sales, Operations, Documentation, Finance, and Compliance in
            one place.
          </div>
          <div className="orange-text body-text-3" style={{ marginTop: '0.75rem' }}>
            The only app you'll ever need to run your business.
          </div>
        </div>

        {/* Link columns */}
        <div className="footer-right-section">
          <div className="link-section-child">
            <div className="about-heading body-text-3">Company</div>
            <div className="link-container">
              {COMPANY_LINKS.map((l) => (
                <FooterLink key={l.label} {...l} />
              ))}
            </div>
          </div>

          <div className="link-section-child">
            <div className="about-heading body-text-3">Legal</div>
            <div className="link-container">
              {LEGAL_LINKS.map((l) => (
                <FooterLink key={l.label} {...l} />
              ))}
            </div>
          </div>

          <div className="footer-contact-column">
            <div className="link-section-child">
              <div className="about-heading body-text-3">Contact</div>
              <a
                href="mailto:sales@shipmnts.com"
                className="body-text-3"
                style={{ textDecoration: 'underline' }}
              >
                sales@shipmnts.com
              </a>
            </div>
            <div className="socials-section">
              <div className="socials">
                <a
                  href="https://in.linkedin.com/company/shipmnts"
                  target="_blank"
                  rel="noreferrer"
                  className="social-link"
                >
                  <img src={LinkedIn} alt="LinkedIn" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Divider className="about-divider" />

      <div className="footer-text-container">
        <span className="crafted-text body-text-4">Crafted with 💜 in India</span>
        <span className="copyright-text body-text-4">
          ©{new Date().getFullYear()} Logistixian Technologies Private Limited.
        </span>
      </div>
    </div>
  );
}
